/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function NetflixLogo(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 90 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18442_162861)">
        <g clipPath="url(#clip1_18442_162861)">
          <path
            d="M12.1049 34.6402C10.7337 34.881 9.33841 34.9532 7.89503 35.1454L3.4925 22.251V35.6988C2.12131 35.8431 0.870379 36.0356 -0.428711 36.228V11.5938H3.22804L8.23177 25.571V11.5938H12.1049V34.6402ZM19.6829 20.6151C21.1745 20.6151 23.4599 20.5429 24.8311 20.5429V24.3919C23.123 24.3919 21.1264 24.3919 19.6829 24.4641V30.1898C21.9443 30.0455 24.2057 29.8528 26.491 29.7807V33.4852L15.8337 34.3274V11.5938H26.491V15.4429H19.6829V20.6151ZM40.8048 15.443H36.8114V33.1488C35.5123 33.1488 34.2132 33.1488 32.9625 33.1968V15.443H28.9691V11.5938H40.805L40.8048 15.443ZM47.0596 20.3505H52.3281V24.1996H47.0596V32.9323H43.2824V11.5938H54.0361V15.4429H47.0596V20.3505ZM60.2909 29.5643C62.4801 29.6122 64.6932 29.7809 66.8344 29.901V33.702C63.3943 33.4854 59.9541 33.2692 56.4419 33.1968V11.5938H60.2909V29.5643ZM70.082 33.9667C71.3089 34.039 72.608 34.1112 73.859 34.2553V11.5938H70.082V33.9667ZM90.723 11.5938L85.8394 23.3095L90.723 36.228C89.2794 36.0356 87.8361 35.7709 86.3926 35.5303L83.6262 28.4096L80.8118 34.9532C79.4162 34.7124 78.069 34.6402 76.674 34.4477L81.6296 23.165L77.1549 11.5938H81.2925L83.8185 18.0651L86.513 11.5938L90.723 11.5938Z"
            fill="#D81F26"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18442_162861">
          <rect width="90" height="48" fill="white" />
        </clipPath>
        <clipPath id="clip1_18442_162861">
          <rect
            width="91.1517"
            height="24.6343"
            fill="white"
            transform="translate(-0.428223 11.5938)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

NetflixLogo.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default NetflixLogo
